import { render, staticRenderFns } from "./FilterCustomers.vue?vue&type=template&id=2fdd2f45&"
import script from "./FilterCustomers.vue?vue&type=script&lang=js&"
export * from "./FilterCustomers.vue?vue&type=script&lang=js&"
import style0 from "./FilterCustomers.vue?vue&type=style&index=0&id=2fdd2f45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports